<modal-form-container
  class="selectedOrganization"
  title="Upload phone numbers"
  className="lg:w-[1200px] md:w-[90vw] w-full h-full md:h-[85%] !max-h-full flex flex-col"
  [showModal]="open"
  [showFooter]="currentIndex > 0"
  (closeModalEvent)="closeModal()"
  contentClass="h-full flex flex-col overflow-hidden !px-0 mt-0 max-h-full md:max-h-[75vh]"
  leftFooterButtonLabel="Back"
  [rightFooterButtonLabel]="getRightButtonLabel"
  [rightFooterButtonDisabled]="nextDisabled"
  leftFooterButtonClass="flex"
  footerClass="flex justify-end gap-2 md:gap-4"
  (rightFooterButtonClick)="getNextFunction()"
  (leftFooterButtonClick)="getPreviousFunction?.()"
>
  <app-simple-stepper
    [steps]="steps"
    [currentIndex]="currentIndex"
    [noContent]="true"
    contentClass="mt-0 flex-grow h-full"
    headerClass="border-b mt-0 px-2 md:px-4"
    class=""
  />
  <div class="contentsContainer csvu__body h-full overflow-y-auto">
    @switch (currentIndex) { @case (3) {
    <csv-phone-numbers-review />
    } @case (2) {
    <list-csv-phone-numbers />
    } @case (1) {
    <map-csv-columns />
    } @default {
    <upload-csv-phone-number-file (goToDataPreviewPage)="goToColumnMapping()" />
    } }
  </div>
</modal-form-container>
